import merge from "lodash/merge";
import {modify} from "mythil/object";
import {CHANGE_PAGE, CHANGE_PER_PAGE, CHANGE_SORT } from "~/actions/result_param_actions";
import { getInitialFilterValues } from "../stateGetter";
import { getFitleredViewState } from "../StateGetters/FilteredViewStateGetters";

export function reduceResultParams(model, action, state) {
    switch(action.type) {
        case CHANGE_PAGE:
            return modify(model, 'results.value.page', action.page);
        case CHANGE_PER_PAGE:
            return modify(model, 'resultParams.perPage', action.perPage);
        case CHANGE_SORT:
            return modify(model, 'resultParams.sortOptions', action.sort);
    }

    return model;
}